function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { StimulusUse } from '../stimulus_use';
import { composeEventName, extendedEvent, method } from '../support/index';
var defaultOptions = {
  dispatchEvent: true,
  eventPrefix: true
};
export var UseVisibility = /*#__PURE__*/function (_StimulusUse) {
  _inherits(UseVisibility, _StimulusUse);

  var _super = _createSuper(UseVisibility);

  function UseVisibility(controller) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseVisibility);

    _this = _super.call(this, controller, options);

    _this.observe = function () {
      _this.controller.isVisible = !document.hidden;
      document.addEventListener('visibilitychange', _this.handleVisibilityChange);
    };

    _this.unobserve = function () {
      document.removeEventListener('visibilitychange', _this.handleVisibilityChange);
    }; // private


    _this.becomesInvisible = function (event) {
      var eventName = composeEventName('invisible', _this.controller, _this.eventPrefix);
      _this.controller.isVisible = false;
      method(_this.controller, 'invisible').call(_this.controller);

      _this.log('invisible', {
        isVisible: false
      });

      _this.dispatch(eventName, event);
    };

    _this.becomesVisible = function (event) {
      var eventName = composeEventName('visible', _this.controller, _this.eventPrefix);
      _this.controller.isVisible = true;
      method(_this.controller, 'visible').call(_this.controller);

      _this.log('visible', {
        isVisible: true
      });

      _this.dispatch(eventName, event);
    };

    _this.dispatch = function (eventName, event) {
      if (_this.dispatchEvent) {
        var detail = {
          controller: _this.controller,
          isVisible: _this.controller.isVisible
        };
        var visibilityEvent = extendedEvent(eventName, event || null, detail);

        _this.controller.element.dispatchEvent(visibilityEvent);

        _this.log('dispatchEvent', Object.assign({
          eventName: eventName
        }, detail));
      }
    };

    _this.handleVisibilityChange = function (event) {
      if (document.hidden) {
        _this.becomesInvisible(event);
      } else {
        _this.becomesVisible(event);
      }
    };

    var _Object$assign = Object.assign({}, defaultOptions, options),
        dispatchEvent = _Object$assign.dispatchEvent,
        eventPrefix = _Object$assign.eventPrefix;

    Object.assign(_assertThisInitialized(_this), {
      dispatchEvent: dispatchEvent,
      eventPrefix: eventPrefix
    });
    _this.controller = controller;

    var disconnect = function disconnect() {
      _this.unobserve();

      _this.controllerDisconnect();
    };

    Object.assign(controller, {
      disconnect: disconnect
    }); // triggers initial callback on connect

    _this.handleVisibilityChange();

    _this.observe();

    return _this;
  }

  return UseVisibility;
}(StimulusUse);
export var useVisibility = function useVisibility(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseVisibility(controller, options);
  return [observer.observe, observer.unobserve];
};